<template>
  <section class="under-construction">
    <div class="card">
      <img src="@/assets/logo.png" alt="OCN Gübre" class="logo" />
      <p class="eyebrow">Kariyer</p>
      <h1>Kariyer sayfamız yapım aşamasında</h1>
      <p class="lede">
        Açık pozisyonları ve ekibimizi daha net anlatan sade bir deneyim için çalışıyoruz.
        Kısa süre içinde yeni sayfa yayında olacak.
      </p>
      <div class="actions">
        <a class="primary" href="mailto:ocngubre@mail.com">Bize ulaşın</a>
        <a class="ghost" href="/">Ana sayfaya dön</a>
      </div>
      <p class="note">Soru ve başvurular için: ocngubre@mail.com</p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'UnderConstruction'
};
</script>

<style scoped>
.under-construction {
  flex: 1;
  height: 100%;
  min-height: 100%;
  width: 100%;
  display: grid;
  place-items: center;
  padding: 16px;
  background: #f5f7fb;
  color: #1e2c3a;
}

.card {
  width: min(720px, 100%);
  background: #ffffff;
  border: 1px solid #e4e8ee;
  border-radius: 16px;
  padding: 22px 20px;
  box-shadow: 0 18px 36px rgba(0, 0, 0, 0.08);
  display: grid;
  justify-items: center;
  gap: 12px;
  text-align: center;
}

.logo {
  height: 64px;
  width: auto;
}

.eyebrow {
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 1.6px;
  font-size: 0.82rem;
  color: #4c5a6b;
}

h1 {
  margin: 4px 0 8px;
  font-size: clamp(1.6rem, 2.6vw, 2rem);
  letter-spacing: -0.01em;
}

.lede {
  margin: 0 0 4px;
  color: #4c5a6b;
  line-height: 1.5;
  max-width: 560px;
}

.actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
  margin: 4px 0 8px;
}

.primary,
.ghost {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 16px;
  border-radius: 10px;
  font-weight: 700;
  text-decoration: none;
  transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
}

.primary {
  background: #1f4b6e;
  color: #ffffff;
  border: 1px solid #1f4b6e;
}

.primary:hover {
  transform: translateY(-1px);
}

.ghost {
  background: #ffffff;
  color: #1f4b6e;
  border: 1px solid #cbd4df;
}

.ghost:hover {
  transform: translateY(-1px);
  border-color: #1f4b6e;
}

.note {
  margin: 0;
  color: #4c5a6b;
  font-size: 0.95rem;
}

@media (max-width: 480px) {
  .card {
    padding: 22px 18px;
  }

  .actions {
    flex-direction: column;
  }

  .primary,
  .ghost {
    width: 100%;
  }
}
</style>
